import { ProviderApi, ProviderStatus, ProviderType } from "@asd/customer-portal-api";
import { AxiosResponse } from "axios";

import AxiosConfigurations, { AxiosConfiguration } from "./AxiosConfiguration";

import { axiosInstance } from ".";

export class ProviderService {
  static instance: ProviderService;
  private providerApi;
  private axiosConfiguration: AxiosConfiguration | undefined;

  constructor() {
    if (ProviderService.instance) {
      return ProviderService.instance;
    }

    this.providerApi = new ProviderApi(undefined, undefined, axiosInstance);
    const config = AxiosConfigurations.createAxiosConfiguration("providerService", this.providerApi);
    if (!config) {
      throw new Error("Failed to create AxiosConfiguration for providerService");
    }
    this.axiosConfiguration = config;

    ProviderService.instance = this;
  }

  public getPendingRequestCount() {
    return this.axiosConfiguration?.getPendingRequestCount();
  }

  public async getProviders(
    participantId?: string,
    statuses?: ProviderStatus[],
    providerTypes?: ProviderType[],
    providerName?: string,
    page?: number,
    size?: number,
    sort?: Array<string>,
    options: object = {},
  ) {
    if (!this.providerApi) {
      throw new Error("providerApi is not initialized");
    }

    try {
      const response: AxiosResponse = await this.providerApi.getProviders(
        participantId?.length ? participantId : undefined,
        statuses?.length ? statuses : undefined,
        providerTypes?.length ? providerTypes : undefined,
        providerName?.length ? providerName : undefined,
        page,
        size,
        sort?.length ? sort : undefined,
        options,
      );
      return response;
    } catch {
      // do nothing
    }
  }

  public async exportProviders(
    participantId?: string,
    statuses?: ProviderStatus[],
    providerTypes?: ProviderType[],
    providerName?: string,
    sort?: Array<string>,
    options: object = {},
  ) {
    if (!this.providerApi) {
      throw new Error("providerApi is not initialized");
    }

    try {
      const response: AxiosResponse = await this.providerApi.exportProvidersCsv(
        participantId?.length ? participantId : undefined,
        statuses?.length ? statuses : undefined,
        providerTypes?.length ? providerTypes : undefined,
        providerName?.length ? providerName : undefined,
        sort?.length ? sort : undefined,
        options,
      );

      return response.data;
    } catch {
      // do nothing
    }
  }
}

export default new ProviderService();
